import type { CoreDslFormLeafPartial, ViewConfigField } from '@salescore/core'
import { Col, Row } from 'antd'
import type { ReactElement } from 'react'

import { CoreDslFormExtraFormItem } from './CoreDslFormExtraFormItem'
import { CoreDslFormOperatorFormItem } from './CoreDslFormOperatorFormItem'
import { CoreDslFormTermFormItem } from './CoreDslFormTermFormItem'
import type { TargetProperty } from './targetProperty'

// 条件セレクト(spans[1])は選択済み状態だとトリガー幅で ellipsis 切り詰めされる。複数選択項目の演算子ラベルは
// 「次の要素を全て含む」/「次の要素を全ては含まない」のように肯定/否定の識別語が末尾寄りにあり、切り詰められると読み分けられない。
// 24 グリッドは総和固定のため、順序設定(spans[3])から 1 送って条件側を広げる。順序設定列は比較演算子かつ選択肢ありのときだけ
// ボタン 1 個を出す列で、常に入力欄が入る他列より余白がある。
const spans = [7, 7, 7, 3]

export const CoreDslFormLeafFormItems = ({
  onChange,
  leaf,
  availableFields,
  children,
  targetProperty,
}: {
  children: ReactElement
  leaf: CoreDslFormLeafPartial
  onChange: (x: CoreDslFormLeafPartial) => void
  availableFields: ViewConfigField[]
  targetProperty: TargetProperty
}) => (
  <Row justify="space-between" align="middle">
    <Col span={23}>
      <Row justify="start" align="middle" gutter={8}>
        <Col span={spans[0]}>
          <CoreDslFormTermFormItem
            availableFields={availableFields}
            targetProperty={targetProperty}
            term={leaf.left}
            operator={leaf.operator}
            onChange={(term) => {
              onChange({
                ...leaf,
                left: term,
              })
            }}
          />
        </Col>
        {/* termに応じて出しわけ？ */}
        <Col span={spans[1]}>
          <CoreDslFormOperatorFormItem leaf={leaf} onChange={onChange} />
        </Col>
        <Col span={spans[2]}>
          <CoreDslFormTermFormItem
            availableFields={availableFields}
            targetProperty={leaf.left?.type === 'recordNodeVariable' ? leaf.left : targetProperty}
            term={leaf.right}
            operator={leaf.operator}
            asRight
            asRightAndLeftIsRecordVariable={leaf.left?.type === 'recordNodeVariable'}
            onChange={(term) => {
              onChange({
                ...leaf,
                right: term,
              })
            }}
          />
        </Col>
        <Col span={spans[3]}>
          <CoreDslFormExtraFormItem
            leaf={leaf}
            onChange={(extra) => {
              onChange({
                ...leaf,
                extra,
              })
            }}
          />
        </Col>
      </Row>
    </Col>
    <Col span={1}>{children}</Col>
  </Row>
)
